import { Box, Card, CardContent, CardHeader, Container, Grid, Typography } from "@mui/material";

import { format } from "date-fns";
import Translate from "./Translate";
import ChannelSlider from "./ChannelSlider";

interface LandingWithoutFormProps {
  headerTitle: string;
  CardBodyContent: React.ReactElement;
}

export default function LandingWithoutForm({
  headerTitle,
  CardBodyContent
}: LandingWithoutFormProps) {
  return (
    <Box
      component="main"
      sx={{
        backgroundColor: theme => theme.palette.background.paper,
        backgroundImage: "url(/assets/background.svg)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        minHeight: 1024,
        padding: 0
      }}
      className="w-full lg:h-screen flex flex-col justify-center relative"
    >
      <Container
        sx={theme => ({ [theme.breakpoints.down("lg")]: { px: "0 !important" } })}
        className="grow px-0 lg:px-6"
      >
        <Grid className="h-full" container columns={12}>
          <Grid container item xs={12} lg={5}>
            <Grid
              container
              xs={12}
              columns={5}
              sx={theme => ({
                [theme.breakpoints.up("lg")]: {
                  justifyContent: "center"
                }
              })}
            >
              <Grid className="items-center" item xs={12} sm={3} lg={4}>
                <div className="sm:w-[24em] px-8 my-12 sm:pl-8 sm:pr-0 lg:w-auto mx-auto">
                  <img
                    className="md:text-left text-center"
                    src="/assets/bizpik-logo.svg"
                    alt="bizpik-logo"
                  />

                  <Typography
                    className="mb-8 mt-14"
                    sx={{
                      fontSize: 20,
                      mb: 4,
                      mt: 7
                    }}
                    variant="h5"
                    fontWeight={600}
                  >
                    <Translate src="greetings:welcome" />
                  </Typography>
                  <div className="mt-12 w-full">
                    <Typography
                      variant="h3"
                      className="max-w-[12em]"
                      sx={theme => ({
                        fontWeight: 700,
                        fontSize: 24,

                        [theme.breakpoints.up("sm")]: {
                          fontSize: 32
                        }
                      })}
                    >
                      <Translate
                        src="greetings:about"
                        components={{
                          "1": (
                            <Typography
                              variant="h3"
                              sx={theme => ({
                                fontWeight: 800,
                                fontSize: 24,
                                display: "inline",
                                lineHeight: 1.3,
                                color: theme.palette.primary.main,

                                [theme.breakpoints.up("sm")]: {
                                  fontSize: 32
                                }
                              })}
                            />
                          ),
                          "2": (
                            <Typography
                              component="span"
                              sx={theme => ({
                                fontWeight: 800,
                                fontSize: 24,
                                display: "inline",
                                lineHeight: 1.3,
                                borderBottom: `solid 4px ${theme.palette.secondary.main}`,
                                color: theme.palette.secondary.main,

                                [theme.breakpoints.up("sm")]: {
                                  fontSize: 32
                                }
                              })}
                            />
                          ),
                          "3": (
                            <Typography
                              component="span"
                              sx={theme => ({
                                fontWeight: 800,
                                fontSize: 24,
                                display: "inline",
                                lineHeight: 1.3,
                                borderBottom: "none",
                                color: theme.palette.secondary.main,

                                [theme.breakpoints.up("sm")]: {
                                  fontSize: 32
                                }
                              })}
                            />
                          )
                        }}
                      />
                    </Typography>
                    <div className="w-auto overflow-hidden">
                      <ChannelSlider />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={7} className="mr-6" justifyItems="center" alignSelf="center">
            <Card
              sx={{ borderRadius: 6 }}
              classes={{
                root: "lg:max-w-[725px] max-w-[900px] mb-12 mx-6 md:mx-auto"
              }}
            >
              <CardHeader
                sx={{ px: 4, py: 3, background: theme => theme.palette.secondary.main }}
                className="px-8 py-6"
                title={
                  <Typography lineHeight="29px" variant="subtitle1">
                    {headerTitle}
                  </Typography>
                }
              />

              <CardContent
                sx={theme => ({
                  px: 4,
                  py: 3,
                  background: theme.palette.background.default,

                  [theme.breakpoints.down("sm")]: {
                    py: 1.5,
                    px: 2
                  }
                })}
              >
                <Box>{CardBodyContent}</Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ background: theme => theme.palette.secondary.main }}>
        <Container className="py-8 sticky bottom-0">
          <Typography
            sx={theme => ({
              color: theme.palette.grey[400],
              fontSize: 14,
              m: 0,

              [theme.breakpoints.down("sm")]: {
                textAlign: "center"
              }
            })}
            variant="caption"
            className="block"
          >
            &copy; {format(Date.now(), "yyyy")} BizPik® |&nbsp;
            <Translate src="greetings:copyright" />
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
